import styled from 'styled-components'

export const Wrapper = styled.div`
    box-shadow: 0px 2px 8px 0px rgba(62, 85, 115, 0.24);
    border-radius: 8px;
    border: 1px solid #E8E8E8;
    background-color: #ffffff;
    padding: 10px;
    
`